
import axios from 'axios'
import { getAccessToken } from '../../utils';
import {
    DELETE_LIST_OF_MUSIC_START,
    DELETE_LIST_OF_MUSIC_SUCCESS,
    DELETE_LIST_OF_MUSIC_FAIL,

    GET_SINGLE_SONG_START,
    GET_SINGLE_SONG_SUCCESS,
    GET_SINGLE_SONG_FAIL,

    UPDATE_SINGLE_SONG_START,
  UPDATE_SINGLE_SONG_SUCCESS,
  UPDATE_SINGLE_SONG_FAIL,



UPLOAD_FILE_START,
UPLOAD_FILE_SUCCESS,
UPLOAD_FILE_FAIL,

UPLOAD_FILE_MENUALLY_START,
UPLOAD_FILE_MENUALLY_SUCCESS,
UPLOAD_FILE_MENUALLY_FAIL,

GET_SOLDMUSIC_HISTORY_START,
GET_SOLDMUSIC_HISTORY_SUCCESS,
GET_SOLDMUSIC_HISTORY_FAIL,

DELETE_SOLD_HISTOYR_START,
DELETE_SOLD_HISTOYR_SUCCESS,
DELETE_SOLD_HISTOYR_FAIL,

GET_MUSIC_FOR_TOP_LIST_START,
GET_MUSIC_FOR_TOP_LIST_SUCCESS,
GET_MUSIC_FOR_TOP_LIST_FAIL,

UPDATE_TOP_LIST_START,
UPDATE_TOP_LIST_SUCCESS,
UPDATE_TOP_LIST_FAIL,


GET_REQUESTED_MUSIC_LIST_START,
GET_REQUESTED_MUSIC_LIST_SUCCESS,
GET_REQUESTED_MUSIC_LIST_FAIL,

DELETE_REQUESTED_MUSIC_LIST_START,
DELETE_REQUESTED_MUSIC_LIST_SUCCESS,
DELETE_REQUESTED_MUSIC_LIST_FAIL,

GET_ADDS_START,
GET_ADDS_SUCCESS,
GET_ADDS_FAIL,


SEARCH_MUSIC_START,
SEARCH_MUSIC_SUCCESS,
SEARCH_MUSIC_FAIL,

REQUEST_MUSIC_START,
REQUEST_MUSIC_SUCCESS,
REQUEST_MUSIC_FAIL,

GET_SELL_RPORT_START,
GET_SELL_RPORT_SUCCESS,
GET_SELL_RPORT_FAIL,

GET_SELL_RPORT_WITH_GIVEN_DATE_START,
GET_SELL_RPORT_WITH_GIVEN_DATE_SUCCESS,
GET_SELL_RPORT_WITH_GIVEN_DATE_FAIL,

GET_EXTRA_INFO_START,
GET_EXTRA_INFO_SUCCESS,
GET_EXTRA_INFO_FAIL,

CREATE_EXTRA_INFO_START,
CREATE_EXTRA_INFO_SUCCESS,
CREATE_EXTRA_INFO_FAIL,
SET_REQUESTED_STATUS,

} from './ActionType'

import {getAllMusic, getTopMusic} from './MusicAction'


export const deleteListOfMusic = (listOfId, config) => async (dispatch) => {
    try {
        dispatch({type:DELETE_LIST_OF_MUSIC_START})
        await axios.post(process.env.REACT_APP_BACKEND_URL+"/music/deletelistofmusic/", listOfId, config).then((res) => {
          dispatch({
              type:DELETE_LIST_OF_MUSIC_SUCCESS,
              data:res.data
          })

          dispatch()
        
        })

    } catch (err) {
      const error =  err.response ? err.response  : "networkError"
      dispatch({
        type:DELETE_LIST_OF_MUSIC_FAIL,
        data:error
      })
    }
};


export const getSingleMusic = (id, config) => async (dispatch) => {
  try {
      dispatch({type:GET_SINGLE_SONG_START})

      await axios.get(process.env.REACT_APP_BACKEND_URL+`/music/rud/${id}/`, config).then((res) => {

        dispatch({
            type:GET_SINGLE_SONG_SUCCESS,
            data: res.data
        })
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + res.data.access,
          },
        };
        dispatch(getAllMusic(config))
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:GET_SINGLE_SONG_FAIL,
      data:error
    })
  }

};

export const updateMusic = (id, formData, config) => async (dispatch) => {
  try {
      dispatch({type:UPDATE_SINGLE_SONG_START})

      await axios.patch(process.env.REACT_APP_BACKEND_URL+`/music/rud/${id}/`,formData,  config).then((res) => {
        dispatch({
            type:UPDATE_SINGLE_SONG_SUCCESS,
            data: res.data
        })
        const config = {
          headers: {
            "Content-Type": "application/json",
            
          },
        };
        
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:UPDATE_SINGLE_SONG_FAIL,
      data:error
    })

  }

};

let uploadCounter = 0;
export const uploadMusic = (formData, music, config, id) => async (dispatch) => {
  uploadCounter++;
  id = id || `${uploadCounter}_${Math.random()}`
  try {
      
      dispatch({type:UPLOAD_FILE_START, data:{
        music:music,
        id:id
      } })


      await axios.post(process.env.REACT_APP_BACKEND_URL+`/music/uplaod/`,formData, { ...config,
          headers: {
            ...config.headers,
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
        dispatch({
            type:UPLOAD_FILE_SUCCESS,
            data:{
              music:music,
              id:id
            }
           
            
        })
        dispatch(getAllMusic('', 1))        
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:UPLOAD_FILE_FAIL,
      data:{
        error:error,
        music:music,
        id:id,
        errorMessage: error.data && error.data['general'],
        errors: error.data['spotify'] || error.data['youtube'] ? error.data : null,
      }
    })
    // dispatch(getSingleMusic(id, config))
  }

};


export const uploadMusicMenually = (formData, config) => async (dispatch) => {
  try {
      
      dispatch({type:UPLOAD_FILE_MENUALLY_START})


      await axios.post(process.env.REACT_APP_BACKEND_URL+`/music/uplaodmanually/`,formData, config).then((res) => {
        dispatch({
            type:UPLOAD_FILE_MENUALLY_SUCCESS,
            
        })  
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({type:UPLOAD_FILE_MENUALLY_FAIL,
    data:error
  
  })
  }

};



export const getSoldMusicHistory = (config) => async (dispatch) => {

  try {
      
      dispatch({type:GET_SOLDMUSIC_HISTORY_START})
  

      await axios.get(process.env.REACT_APP_BACKEND_URL+`/music/soldmusichistory`, config).then((res) => {

        dispatch({
            type:GET_SOLDMUSIC_HISTORY_SUCCESS,
            data:res.data            
        })
        
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:GET_SOLDMUSIC_HISTORY_FAIL,
      data:error
    })
   
  }

};


export const deleteSoldHistory = (listOfId, config) => async (dispatch) => {
  try {
      dispatch({type:DELETE_SOLD_HISTOYR_START})
      await axios.post(process.env.REACT_APP_BACKEND_URL+"/music/deletesoldhistry/", listOfId, config).then((res) => {
        dispatch({
            type:DELETE_SOLD_HISTOYR_SUCCESS
        })
        dispatch(getSoldMusicHistory(config))
      })
  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:DELETE_SOLD_HISTOYR_FAIL,
      data:error
    })
  }
};

export const getRequestedMusicList = (config) => async (dispatch) => {
  try {
      dispatch({type:GET_REQUESTED_MUSIC_LIST_START})
      
      await axios.get(process.env.REACT_APP_BACKEND_URL+"/music/musicrequestlist",config).then((res) => {
        
        dispatch({
            type:GET_REQUESTED_MUSIC_LIST_SUCCESS,
            data:res.data
        })

      
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:GET_REQUESTED_MUSIC_LIST_FAIL,
      data:error
    })
  }
};

export const deleteRequestedMusicList = (id, config) => async (dispatch) => {
  try {
      dispatch({type:DELETE_REQUESTED_MUSIC_LIST_START})
      
      await axios.post(process.env.REACT_APP_BACKEND_URL+"/music/deletemusicrequestlist/", id, config).then((res) => {
        
        dispatch({
            type:DELETE_REQUESTED_MUSIC_LIST_SUCCESS,
        })
        dispatch(getRequestedMusicList(config))
      
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:DELETE_REQUESTED_MUSIC_LIST_FAIL,
      data:error
    })
  }
};


export const getAdds = () => async (dispatch) => {
  try {
      dispatch({type:GET_ADDS_START})
      
      await axios.get(process.env.REACT_APP_BACKEND_URL+"/music/listofadd/", ).then((res) => {
        
        dispatch({
            type:GET_ADDS_SUCCESS,
            data:res.data
        })
      
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:GET_ADDS_FAIL,
      data:error
    })
  }
};


export const searchMusic = (song, config) => async (dispatch) => {
  try {
      dispatch({type:SEARCH_MUSIC_START})
      
      await axios.post(process.env.REACT_APP_BACKEND_URL+"/music/searchMusic/", song, config ).then((res) => {
        
        dispatch({
            type:SEARCH_MUSIC_SUCCESS,
            data:res.data
        })
      
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:SEARCH_MUSIC_FAIL,
      data:error
    })
  }
};


export const requestMusic = (spotifyId, searchQuery, accessToken) => async (dispatch) => {
  try {
      dispatch({type:REQUEST_MUSIC_START})

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };

      const url = process.env.REACT_APP_BACKEND_URL+`/subscriptions/new-song/`;
      
      await axios.post(url, { spotifyId, searchQuery }, config).then((res) => {
        dispatch({
            type:REQUEST_MUSIC_SUCCESS,
            data:res.data
        })
        dispatch({
          type:SET_REQUESTED_STATUS,
          data:{ [spotifyId]: 'requested' }
        })
      })
  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:REQUEST_MUSIC_FAIL,
      data:error
    })
  }
};



export const getSellsReport = (config) => async (dispatch) => {
  try {
      dispatch({type:GET_SELL_RPORT_START})
      
      await axios.get(process.env.REACT_APP_BACKEND_URL+`/music/sellreport`, config ).then((res) => {
        dispatch({
            type:GET_SELL_RPORT_SUCCESS,
            data:res.data
        })
      
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:GET_SELL_RPORT_FAIL,
      data:error
    })
  }
};



export const getSellsReportWithGiveDate = (fromDate, config) => async (dispatch) => {
  try {
      dispatch({type:GET_SELL_RPORT_WITH_GIVEN_DATE_START})
      
      await axios.post(process.env.REACT_APP_BACKEND_URL+`/music/sellreportwithgivendate/`, fromDate, config ).then((res) => {
        dispatch({
            type:GET_SELL_RPORT_WITH_GIVEN_DATE_SUCCESS,
            data:res.data
        })
      
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:GET_SELL_RPORT_WITH_GIVEN_DATE_FAIL,
      data:error
    })
  }
};


export const getExtraInfo = () => async (dispatch) => {
  try {
      dispatch({type:GET_EXTRA_INFO_START})
      
      await axios.get(process.env.REACT_APP_BACKEND_URL+`/music/extrainfo/` ).then((res) => {
 
        dispatch({
            type:GET_EXTRA_INFO_SUCCESS,
            data:res.data
        })
      
      })

  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:GET_EXTRA_INFO_FAIL,
      data:error
    })
  }
};


export const createExtraInfo = (formData, config) => async (dispatch) => {
  try {
      dispatch({type:CREATE_EXTRA_INFO_START})
      
      await axios.post(process.env.REACT_APP_BACKEND_URL+`/music/createextrainfo/`,formData, config ).then((res) => {
 
        dispatch({
            type:CREATE_EXTRA_INFO_SUCCESS,
        })
        
        dispatch(getExtraInfo())

      })


  } catch (err) {
    const error =  err.response ? err.response  : "networkError"
    dispatch({
      type:CREATE_EXTRA_INFO_FAIL,
      data:error
    })
  }
};


